import config from 'constants/config'

export interface PinSizing {
  size: [number, number]
  anchor: [number, number]
}

interface Pin {
  image: string
  sizing: PinSizing
}

interface PinType {
  default: Pin
  hover: Pin
}

interface PinConfig {
  [key: number]: {
    default: PinType
    active: PinType
    previewed: PinType
  }
}

const defaultSize: PinSizing = {
  size: [39, 48],
  anchor: [20, 45],
}

const expandSize: PinSizing = {
  size: [43, 53],
  anchor: [23, 48],
}

const WINE_AND_DINE = `${config.IMAGE_HOST}/wine-and-dine`
const TOP_ACTIVITIES = `${config.IMAGE_HOST}/top-activities`
const ATTRACTIONS_AND_TICKETS = `${config.IMAGE_HOST}/attractions-and-tickets`
const LIVE_EVENTS = `${config.IMAGE_HOST}/live-events`
const INDULGE_YOURSELF = `${config.IMAGE_HOST}/indulge-yourself`
const TRAVEL_ESSENTIALS = `${config.IMAGE_HOST}/travel-essentials`
const LUX_EXCLUSIVES = `${config.IMAGE_HOST}/LUX-exclusives`
const GUIDED_TOURS = `${config.IMAGE_HOST}/guided-tours`
const PIN_DEFAULT = 'pin-default-x4-v2'
const PIN_ACTIVE = 'pin-active-x4-v2'
const PIN_PREVIEWED = 'pin-previewed-x4-v2'

const ExperiencePins: PinConfig = {
  1: {
    default: {
      default: {
        image: `${WINE_AND_DINE}-${PIN_DEFAULT}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${WINE_AND_DINE}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    active: {
      default: {
        image: `${WINE_AND_DINE}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
      hover: {
        image: `${WINE_AND_DINE}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    previewed: {
      default: {
        image: `${WINE_AND_DINE}-${PIN_PREVIEWED}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${WINE_AND_DINE}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
  },
  9: {
    default: {
      default: {
        image: `${TOP_ACTIVITIES}-${PIN_DEFAULT}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${TOP_ACTIVITIES}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    active: {
      default: {
        image: `${TOP_ACTIVITIES}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
      hover: {
        image: `${TOP_ACTIVITIES}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    previewed: {
      default: {
        image: `${TOP_ACTIVITIES}-${PIN_PREVIEWED}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${TOP_ACTIVITIES}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
  },
  18: {
    default: {
      default: {
        image: `${ATTRACTIONS_AND_TICKETS}-${PIN_DEFAULT}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${ATTRACTIONS_AND_TICKETS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    active: {
      default: {
        image: `${ATTRACTIONS_AND_TICKETS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
      hover: {
        image: `${ATTRACTIONS_AND_TICKETS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    previewed: {
      default: {
        image: `${ATTRACTIONS_AND_TICKETS}-${PIN_PREVIEWED}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${ATTRACTIONS_AND_TICKETS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
  },
  27: {
    default: {
      default: {
        image: `${LIVE_EVENTS}-${PIN_DEFAULT}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${LIVE_EVENTS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    active: {
      default: {
        image: `${LIVE_EVENTS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
      hover: {
        image: `${LIVE_EVENTS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    previewed: {
      default: {
        image: `${LIVE_EVENTS}-${PIN_PREVIEWED}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${LIVE_EVENTS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
  },
  31: {
    default: {
      default: {
        image: `${INDULGE_YOURSELF}-${PIN_DEFAULT}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${INDULGE_YOURSELF}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    active: {
      default: {
        image: `${INDULGE_YOURSELF}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
      hover: {
        image: `${INDULGE_YOURSELF}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    previewed: {
      default: {
        image: `${INDULGE_YOURSELF}-${PIN_PREVIEWED}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${INDULGE_YOURSELF}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
  },
  35: {
    default: {
      default: {
        image: `${TRAVEL_ESSENTIALS}-${PIN_DEFAULT}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${TRAVEL_ESSENTIALS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    active: {
      default: {
        image: `${TRAVEL_ESSENTIALS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
      hover: {
        image: `${TRAVEL_ESSENTIALS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    previewed: {
      default: {
        image: `${TRAVEL_ESSENTIALS}-${PIN_PREVIEWED}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${TRAVEL_ESSENTIALS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
  },
  40: {
    default: {
      default: {
        image: `${LUX_EXCLUSIVES}-${PIN_DEFAULT}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${LUX_EXCLUSIVES}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    active: {
      default: {
        image: `${LUX_EXCLUSIVES}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
      hover: {
        image: `${LUX_EXCLUSIVES}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    previewed: {
      default: {
        image: `${LUX_EXCLUSIVES}-${PIN_PREVIEWED}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${LUX_EXCLUSIVES}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
  },
  48: {
    default: {
      default: {
        image: `${GUIDED_TOURS}-${PIN_DEFAULT}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${GUIDED_TOURS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    active: {
      default: {
        image: `${GUIDED_TOURS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
      hover: {
        image: `${GUIDED_TOURS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    previewed: {
      default: {
        image: `${GUIDED_TOURS}-${PIN_PREVIEWED}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${GUIDED_TOURS}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
  },
  999: {
    default: {
      default: {
        image: `${TOP_ACTIVITIES}-${PIN_DEFAULT}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${TOP_ACTIVITIES}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    active: {
      default: {
        image: `${TOP_ACTIVITIES}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
      hover: {
        image: `${TOP_ACTIVITIES}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
    previewed: {
      default: {
        image: `${TOP_ACTIVITIES}-${PIN_PREVIEWED}`,
        sizing: defaultSize,
      },
      hover: {
        image: `${TOP_ACTIVITIES}-${PIN_ACTIVE}`,
        sizing: expandSize,
      },
    },
  },
}

export default ExperiencePins
